import { render, staticRenderFns } from "./startPractice.vue?vue&type=template&id=4a5dc424&scoped=true"
import script from "./startPractice.vue?vue&type=script&lang=js"
export * from "./startPractice.vue?vue&type=script&lang=js"
import style0 from "./startPractice.vue?vue&type=style&index=0&id=4a5dc424&lang=scss"
import style1 from "./startPractice.vue?vue&type=style&index=1&id=4a5dc424&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5dc424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5dc424')) {
      api.createRecord('4a5dc424', component.options)
    } else {
      api.reload('4a5dc424', component.options)
    }
    module.hot.accept("./startPractice.vue?vue&type=template&id=4a5dc424&scoped=true", function () {
      api.rerender('4a5dc424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/practice/startPractice.vue"
export default component.exports